/* About Us landing */
(function () {
  'use strict';

  var abv = document.getElementById('abHeroVideo');
  if (abv) {
    var src = abv.getAttribute('data-video-src');
    var poster = abv.getAttribute('data-poster-src');
    if (poster) abv.setAttribute('poster', poster);
    if (src) {
      var existing = abv.querySelector('source');
      if (existing) { existing.src = src; }
      else {
        var absrc = document.createElement('source');
        absrc.src = src; absrc.type = 'video/mp4';
        abv.appendChild(absrc);
      }
      abv.load();
    }
    var abShow = function () { if (abv.readyState >= 2) abv.classList.add('ab-playing'); };
    abv.addEventListener('loadeddata', abShow);
    abv.addEventListener('canplay', abShow);
    abShow();
  }

  document.querySelectorAll('.ab-fv[data-video-src], .ab-fv[data-yt-id]').forEach(function (card) {
    if (card.dataset.bound) return;
    card.dataset.bound = '1';
    var open = function () {
      if (card.dataset.loaded) return;
      card.dataset.loaded = '1';
      var frame = card.querySelector('.ab-fv-frame');
      if (!frame) return;
      var vsrc = card.getAttribute('data-video-src');
      var ytid = card.getAttribute('data-yt-id');
      var poster = card.getAttribute('data-poster-src') || '';
      var plain = card.getAttribute('data-title') || '';
      if (vsrc) {
        frame.innerHTML =
          '<video src="' + vsrc + '" controls autoplay playsinline preload="metadata"' +
          (poster ? ' poster="' + poster + '"' : '') +
          ' style="width:100%;height:100%;object-fit:cover;background:#14100F;"></video>';
      } else if (ytid) {
        frame.innerHTML =
          '<iframe src="https://www.youtube-nocookie.com/embed/' + ytid +
          '?autoplay=1&rel=0&modestbranding=1" title="' + plain +
          '" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" ' +
          'allowfullscreen loading="lazy"></iframe>';
      }
    };
    card.addEventListener('click', open);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
  });

  document.querySelectorAll('.ab-car').forEach(function (car) {
    var track = car.querySelector('.ab-car-track');
    var prev  = car.querySelector('.ab-car-prev');
    var next  = car.querySelector('.ab-car-next');
    if (!track || !prev || !next) return;
    var sync = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      var noOverflow = track.scrollWidth <= track.clientWidth + 2;
      prev.style.display = next.style.display = noOverflow ? 'none' : '';
    };
    var page = function (dir) {
      track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
    };
    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    setTimeout(sync, 400);
  });

  if ('IntersectionObserver' in window) {
    var o = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('ab-vis'); o.unobserve(e.target); } });
    }, { threshold:.08, rootMargin:'0px 0px -32px 0px' });
    document.querySelectorAll('.ab-reveal').forEach(function (el) { o.observe(el); });
  } else {
    document.querySelectorAll('.ab-reveal').forEach(function (el) { el.classList.add('ab-vis'); });
  }
  setTimeout(function () {
    document.querySelectorAll('.ab-hero .ab-reveal').forEach(function (el) { el.classList.add('ab-vis'); });
  }, 150);
})();
